import { useState, useRef, useEffect } from 'react';
import { Button as AntButton, Input } from 'antd';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import Data from '../../data/Data';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Reference from '../designers/Reference';

function DesignerSettings({
    fetchDashboard,
    designerReferences,
    user
}) {
    const [validated, setValidated] = useState(false);
    const [error, setError] = useState();
    const [showReference, setShowReference] = useState(false);
    const referenceFormRef = useRef();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [crownPrice, setCrownPrice] = useState(0);
    const [crownEnabled, setCrownEnabled] = useState(false);
    const [projectPrice, setProjectPrice] = useState(0);
    const [projectEnabled, setProjectEnabled] = useState(false);

    useEffect(() => {        
        setCrownPrice(user.crownPrice ?? 0);
        setProjectPrice(user.projectPrice ?? 0);
    }, [user]);
    

    const handleCloseReference = () => {
        setValidated(false);
        setShowReference(false);
        setError(null);
    };

    const handleFileChange = (e) => {
        setSelectedFiles(e.target.files);
    };

    const handleAddReference = async (e) => {
        try {
            e.preventDefault();
            setError(null);

            if (referenceFormRef.current.checkValidity() === false) {
                e.stopPropagation();
                setValidated(true);
            } else {
                setIsLoading(true);

                const formData = new FormData();
                for (let i = 0; i < selectedFiles.length; i++) {
                    formData.append('files', selectedFiles[i], selectedFiles[i].name);
                }

                console.log('Saving reference with files:', formData.getAll('objects'));
                await Data.addReference(formData);
                // TODO: successful message

                handleCloseReference();
                fetchDashboard();
            }
        } catch (err) {
            console.error('Error creating reference:', err);
            setError(err.message);
        } finally {
            setIsLoading(false); // End loading
        }
    };

    const handleDeleteReference = async (referenceName) => {
        const name = referenceName.split('references/')[1].split('/')[1].split('/')[0];
        console.log(name);
        try {
            await Data.deleteReference(name);
            fetchDashboard();
            setError(null);
        } catch (err) {
            console.error('Error deleting reference:', err);
            setError(err.message);
        }
    };

    const onClickCrownPrice = () => {
        if (crownEnabled) {
            Data.updateCrownPrice(crownPrice)
                .then(() => {
                    setCrownEnabled(false);
                })
                .catch((err) => {
                    console.error('Error updating crown price:', err);
                    setError(err.message);
                });
        } else {
            setCrownEnabled(true);
        }
    }

    const onClickProjectPrice = () => {
        if (projectEnabled) {
            Data.updateProjectPrice(projectPrice)
                .then(() => {
                    setProjectEnabled(false);
                })
                .catch((err) => {
                    console.error('Error updating project price:', err);
                    setError(err.message);
                });
        } else {
            setProjectEnabled(true);
        }
    }

    return (
        <div className='DesignerSettings'>
            <div className='row'>
                <div className='col-12'>
                    <p>Prices</p>

                    <div className='row'>
                        <label className='mb-2'>Crown</label>
                        <div className='col-8 col-md-3'>
                            <Input prefix='€' type='number' min={0} step={5} disabled={!crownEnabled} value={crownPrice} onChange={(e) => setCrownPrice(e.target.value)} />
                        </div>
                        <div className='col-4 col-md-3'>
                            <AntButton type="primary" onClick={() => onClickCrownPrice()}>{!crownEnabled ? 'Modify' : 'Save'}</AntButton>
                        </div>
                    </div>

                    <div className='row'>
                        <label className='mt-3 mb-2'>Project price</label>
                        <div className='col-8 col-md-3'>
                        <Input prefix='€' type='number' min={0} step={5} disabled={!projectEnabled} value={projectPrice} onChange={(e) => setProjectPrice(e.target.value)} />
                        </div>
                        <div className='col-4 col-md-3'>
                            <AntButton type="primary" onClick={() => onClickProjectPrice()}>{!projectEnabled ? 'Modify' : 'Save'}</AntButton>
                        </div>
                    </div>

                    <hr className='mt-5' />

                    <div style={{ textAlign: 'right' }}>
                        <AntButton type="primary" className="mb-3" onClick={() => setShowReference(true)}>Add New</AntButton>
                    </div>
                    {designerReferences.map((reference) => (
                        <div className='reference-box p-3 my-3' key={reference.url}>
                            <Reference reference={reference} />

                            <div style={{ textAlign: 'right' }}>
                                <AntButton danger type='primary' size='small' className='me-2' onClick={() => handleDeleteReference(reference.url)}>Delete</AntButton>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Modal show={showReference} onHide={handleCloseReference} backdrop="static" keyboard={false} centered size="lg" scrollable fullscreen="sm-down" style={{zIndex: 9999}}>
                <Modal.Header closeButton>
                    <Modal.Title>Add new reference</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger" dismissible>{error}</Alert>}
                    <Form ref={referenceFormRef} className={`needs-validation ${validated ? 'was-validated' : ''}`} noValidate onSubmit={handleAddReference}>
                        <Form.Group className="mb-3">
                            <Form.Label>References (.STL files)</Form.Label>
                            <Form.Control required type="file" multiple accept='.stl' onChange={handleFileChange} disabled={isLoading} />
                            <Form.Control.Feedback type="invalid">Please provide a file.</Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {isLoading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
                    <Button disabled={isLoading} variant="primary" onClick={handleAddReference}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DesignerSettings;